import Header from "./Header";
import Footer from "./Footer";
import About from "./about/About";
import Services from "./services/Services";
import Home from "./home/Home";
import Team from "./team/Team";
import FeedBack from "./feedback/FeedBack";
import {useEffect} from "react";
import GalleryDisplay from "./galerie/GalleryDisplay";
import Offers from "./offer/Offers";

const services = [
    {
        id: 6,
        title: 'Formation et ressources éducative',
        description: 'Nous mettons en place des ressources de formation et d\'éducation en ligne pour aider les agriculteurs à améliorer leurs compétences techniques, à adopter des pratiques agricoles durables et à rester informés des dernières avancées dans le domaine de l\'agriculture.',
        photo: 'services/formation-et-ressources-educative.webp',
        link: 'formation-et-ressources-educative'
    },
    {
        id: 2,
        title: 'Surveillance des cultures avancée',
        description: 'Nous proposons une surveillance des cultures avancée en utilisant des technologies telles que la télédétection et les drones, permettant aux agriculteurs de surveiller la santé de leurs cultures et de détecter les problèmes précoces.',
        photo: 'services/surveillance-des-cultures-avancee.webp',
        link: 'surveillance-des-cultures-avancee'
    },
    {
        id: 1,
        title: 'Conseils agronomiques personnalisés',
        description: ' Nous offrons des conseils individualisés aux agriculteurs en fonction de vos besoins spécifiques, de' +
            ' vos cultures et de votre emplacement, afin de vous aider à optimiser vos pratiques agricoles.',
        photo: 'services/conseils-agronomiques-personnalises.webp',
        link: 'conseils-agronomiques-personnalises'
    },
    {
        id: 5,
        title: 'Plateforme de marché agricole en ligne',
        description: 'Nous créons une plateforme de marché en ligne où les agriculteurs peuvent acheter et vendre des produits agricoles, des intrants, des équipements et d\'autres fournitures, facilitant ainsi le commerce et la connectivité dans le secteur agricole.',
        photo: 'services/plateforme-de-marche-agricole-en-ligne.webp',
        link: 'plateforme-de-marche-agricole-en-ligne'
    },
    {
        id: 4,
        title: 'Gestion intelligente de l\'eau',
        description: 'Nous développons des solutions de gestion de l\'eau intelligentes pour aider les agriculteurs à optimiser leur utilisation de l\'eau, à surveiller les niveaux d\'humidité du sol et à mettre en œuvre des pratiques d\'irrigation efficaces.',
        photo: 'services/gestion-intelligente-de-l-eau.webp',
        link: 'gestion-intelligente-de-l-eau'
    },
    {
        id: 3,
        title: 'Analyse approfondie des sols',
        description: 'Nous fournissons des services d\'analyse des sols complets pour aider les agriculteurs à comprendre la composition de leurs sols et à prendre des décisions éclairées en matière de gestion.',
        photo: 'services/analyse-approfondie-des-sols.webp',
        link: 'analyse-approfondie-des-sols'
    },
]
const abouts = [
    {
        title: 'Contexte agricole à Madagascar',
        description: 'A Madagascar, le développement du secteur agricole et celui du monde rural sont considérés à juste titre comme un enjeu stratégique majeur sur le plan national. En effet, la population rurale dépend presque intégralement des activités agricoles. En 2018, Madagascar comptait au total 5 060 888 ménages agricoles, soit 83,2 % de tous les ménages, dont 592 644 ménages (11,7 %) résident en milieu urbain et 4 468 244 (88,3 %) en milieu rural (INSTAT, 2020).',
        photo: 'about/contexte-agricole-a-madagascar.webp',
        link: 'contexte-agricole-a-madagascar',
        change: false
    },
    {
        title: 'Importance économique de l\'agriculture',
        description: 'Sur le plan macroéconomique, le secteur de l’Agriculture (agriculture, élevage, pêche) représente un pôle essentiel du développement économique du pays, avec une contribution au PIB en 2018 de 24%. Il constitue le fer de lance de l’économie malgache (INSTAT, 2021). Le milieu rural fournit 70% des activités du pays, dont le taux d’activité est de 66,5%.',
        photo: 'about/importance-economique-de-l-agriculture.webp',
        link: 'importance-economique-de-l-agriculture',
        change: false
    },
    {
        title: 'Défis  pour l\'agriculture rurale',
        description: 'Cependant, malgré son rôle essentiel, l\'image du métier agricole est souvent négligée. Le métier d\'agriculteur n\'est pas attrayant pour les jeunes, qui rencontrent des difficultés à maîtriser les techniques agricoles et à gérer efficacement leurs exploitations, souvent sans accès à la technologie dans les zones rurales. Ils utilisent des matériels rudimentaires et des techniques culturales destructrices pour l\'environnement, contribuant à un taux de chômage élevé et à l\'insécurité alimentaire et humaine en milieu rural.',
        photo: 'about/defis-et-solutions-pour-l-agriculture-rurale.webp',
        link: 'defis-et-solutions-pour-l-agriculture-rurale',
        change: false
    },
    {
        title: 'Quelles sont nos objectifs?',
        description: "Agri-Tech Solution aspire à bâtir un avenir durable en priorisant l\'agriculture dans la quête d\'autosuffisance alimentaire. Notre objectif principal est de développer des solutions innovantes pour soutenir l\'agriculture durable non seulement à Madagascar, mais aussi dans d\'autres pays désireux de collaborer en Afrique et au Moyen-Orient. Notre projet repose sur l\'utilisation de technologies de pointe, notamment l\'intelligence artificielle, pour créer une application Smart Farming. Cette initiative révolutionnaire simplifie la gestion agricole tout en offrant des itinéraires techniques spécifiques à chaque culture. En combinant des données agricoles précises avec des analyses avancées, notre application fournit des recommandations personnalisées pour améliorer les rendements, réduire les pertes et promouvoir une agriculture plus efficace.",
        photo: 'about/vision-et-objectifs-d-agri-tech-solution.webp',
        link: 'vision-et-objectifs-d-agri-tech-solution',
        change: true
    },
    {
        title: 'Nos impacts socials et environnementals?',
        description: "Au-delà de l'aspect technologique, Agri-Tech Solution s'engage à créer un impact social significatif. Nous visons à réduire le chômage rural en créant des opportunités d'emploi dans le secteur agricole, à promouvoir une gestion agricole plus efficace pour améliorer les moyens de subsistance des agriculteurs et à lutter contre la dégradation environnementale en encourageant des pratiques agricoles durables.\n" +
            "\n" +
            "Agri-tech Solution se distingue par son potentiel transformateur dans le domaine agricole. Rejoignez-nous dans cette mission ambitieuse avec notre engagement à améliorer les conditions de vie des communautés rurales et à construire un avenir plus résilient et prospère.",
        photo: 'about/impact-social-et-environnemental.webp',
        link: 'impact-social-et-environnemental',
        change: false
    }
]
function Welcome() {
    const isConnected = () => {
        return sessionStorage.getItem('auth') !== null
    }

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!entry.target.classList.contains("in-view")) {
                        entry.target.classList.add("in-view");
                    }
                    return;
                }
                entry.target.classList.remove("in-view")
            })
        });
        const allAnimatedElements = document.querySelectorAll(".animate");
        allAnimatedElements.forEach((element) => observer.observe(element))
    }, []);
    return (
        <>
            <Header isConnected={isConnected()}></Header>
            <Home></Home>
            <About abouts={abouts}/>
            <Services services={services}/>
            <Offers></Offers>
            <Team></Team>
            <GalleryDisplay></GalleryDisplay>
            <FeedBack></FeedBack>
            <Footer services={services} abouts={abouts} ></Footer>
        </>
    )
}
export default Welcome;